import {
  FETCH_TELECALLER_LEADS_START,
  FETCH_TELECALLER_LEADS_SUCCESS,
  FETCH_TELECALLER_LEADS_ERROR,
  FETCH_UNRECEIVED_CALL_LEADS_START,
  FETCH_UNRECEIVED_CALL_LEADS_SUCCESS,
  FETCH_UNRECEIVED_CALL_LEADS_ERROR,
} from "../types/telecallerTypes";

import { getTelecallerLeadsService , getUnreceivedCallLeadsService, routeToServiceCallerService} from "../../services/telecallersService"

export const fetchTelecallerLeads = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_TELECALLER_LEADS_START });

      const response = await getTelecallerLeadsService(payload);

      dispatch({
        type: FETCH_TELECALLER_LEADS_SUCCESS,
        payload: response.data?.data?.leads || [], // ✅ FIX
      });
    } catch (error) {
      dispatch({
        type: FETCH_TELECALLER_LEADS_ERROR,
        payload: error.message,
      });
    }
  };
};


export const fetchUnreceivedCallLeads = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_UNRECEIVED_CALL_LEADS_START });

      const response = await getUnreceivedCallLeadsService(payload);

      dispatch({
        type: FETCH_UNRECEIVED_CALL_LEADS_SUCCESS,
        payload: response.data?.leads || [],
      });
      
    } catch (error) {
      dispatch({
        type: FETCH_UNRECEIVED_CALL_LEADS_ERROR,
        payload: error.message,
      });
    }
  };
};

export const routeToServiceCallerAction = (payload) => {

  return async (dispatch) => {

    try {

      const response =
        await routeToServiceCallerService(
          payload
        );

      console.log(
        "ROUTE RESPONSE",
        response
      );

      if (
        response?.data?.status === "success"
      ) {

        return {
          success: true,
          message:
            response.data?.message,
        };

      } else {

        throw new Error(
          response.data?.message ||
          "Failed to route lead"
        );
      }

    } catch (error) {

      console.error(
        "Route to Service Caller Error:",
        error
      );

      return {
        success: false,
        message:
          error?.response?.data?.message ||
          error.message,
      };
    }
  };
};